import { Component, Input, output, ViewChild } from '@angular/core';
import { Drawer, DrawerModule } from 'primeng/drawer';
import { LanguageService, PIMContactDetailsv2 } from 'core-lib';
import { SettingsService } from 'core-lib';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvailabilityService } from 'core-lib';
import { ImageGallery1Component } from "../image-gallery1/image-gallery1.component";
import { MapComponent } from "../map/map.component";
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { GalleryRef } from 'ng-gallery';
import { ConfirmationCommondetailsComponent } from "../confirmation-commondetails/confirmation-commondetails.component";


@Component({
    selector: 'hotel-details-popup',
    imports: [DrawerModule, TranslateModule, ImageGallery1Component, ButtonModule, SelectButtonModule, FormsModule, MapComponent],
    templateUrl: './hotel-details-popup.component.html',
    styleUrl: './hotel-details-popup.component.scss'
})
export class HotelDetailsPopupComponent {

  @ViewChild('drawerRef') drawerRef!: Drawer;

  @ViewChild(ImageGallery1Component, { static: false })
  private imageGalleryComponent: ImageGallery1Component;
  
  @Input() roomData: any; 
  @Input() visible:boolean = false;
  @Input() hotelData:any;
  @Input() hotelCode:undefined|string;
  @Input() contactDetails:PIMContactDetailsv2|null;
  onHide:any = output();  
  language:string;

  stateOptions: any[] = [];

  stateValue: string = 'details';
  
  constructor(private settings:SettingsService, private translateService: TranslateService, private avService: AvailabilityService){}

  ngOnInit(): void {
    this.language = this.translateService.currentLang;

    this.stateOptions.push(
      { label: this.translateService.instant('av.HotelDetails'), value: 'details' }
    );
    this.stateOptions.push(
      { label: this.translateService.instant('av.Images'), value: 'images' }
    );    
  }

  handleOnHide(e:any) {
    this.drawerRef.close(e);
    this.onHide.emit();
  }

  handleOptionChange(event:any) {
    if (event.option.value == "images") {
      this.imageGalleryComponent.reset();
    }
  }


  
}
